import React, { useEffect, useState } from 'react';
import OduLandingPage from '../../../features/odu/components/OduLandingPage';
import { safeJsonParse } from '../../../Shared/utils/commonutils';

const OduComponent = () => {
    const [deviceDetails, setDeviceDetails] = useState({})

    useEffect(() => {
        let details = sessionStorage.getItem('devices_detail');
        if (details) {
            details = safeJsonParse(details);
            setDeviceDetails(details);
        }
    }, [])


    return (<>
        {!!Object.entries(deviceDetails)?.length && <OduLandingPage deviceDetails={deviceDetails} />}
    </>)
}

export default OduComponent;
